// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"148":"b3b8865d21b72ade","197":"b21e41bf7d329e59","332":"500d8d726e06575a","888":"4352cd027b49d176"}[chunkId] + ".css";
};